import { gql } from '@apollo/client' ;

export default gql`
  mutation markEducationAsComplete($id: ID!) {
    completeEducation(input: {
      id: $id,
    }) {
      carePlanActivity {
        id
        status
      }
    }
  }
`;
